/* HARUM (HAR-148): the "Send Inquiry" contact forms on the imported pages
   (group-order / dropship / wholesale) used to post to Shopify's native
   /contact endpoint, whose notification email goes to the store's Shopify
   sender address and never reached CS. Intercept the submit and post the
   inquiry to supply.harum.io (dropship platform) instead, which emails CS
   directly (app/api/inquiries in the harumio-dropship-platform repo).
   If the API call fails, fall back to the original native /contact submit
   so no inquiry is ever lost.

   Note: Shopify injects an inline `captcha-bootstrap` script that listens for
   submit events on contact forms and re-submits them natively, ignoring
   preventDefault. The Send Inquiry button is therefore switched to
   type="button" so no submit event ever fires on the happy path. */
(function () {
  'use strict';

  /* on `shopify theme dev` (127.0.0.1:9292) talk to a local dropship-platform
     dev server (`npx next dev` in harumio-dropship-platform) instead of prod */
  var API_URL = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
    ? 'http://localhost:3000/api/inquiries'
    : 'https://supply.harum.io/api/inquiries';

  function fieldLabel(value) {
    /* value-less checked checkboxes serialize as "on" */
    return value === 'on' ? 'Yes' : value;
  }

  function buildPayload(form, source) {
    var payload = {
      source: source,
      pageUrl: window.location.href,
      fields: {},
    };
    new FormData(form).forEach(function (value, key) {
      if (typeof value !== 'string' || value.trim() === '') return;
      var match = key.match(/^contact\[(.+)\]$/);
      if (!match) return; /* form_type, utf8 */
      var name = match[1];
      if (name === 'name') payload.name = value;
      else if (name === 'email') payload.email = value;
      else if (name === 'Message' || name === 'body') payload.message = value;
      else if (name === 'source') return; /* stale hard-coded page URL */
      else payload.fields[name] = fieldLabel(value);
    });
    return payload;
  }

  function showSuccess(form) {
    var success = document.createElement('div');
    success.className = 'harum-inquiry-success';
    success.innerHTML =
      '<h3>Thank you for your inquiry!</h3>' +
      '<p>Our team has received your message and will get back to you as soon as we can.</p>';
    form.parentNode.insertBefore(success, form);
    form.style.display = 'none';
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setSending(form, sending) {
    var button = form.querySelector('.harum-inquiry-send');
    if (!button) return;
    button.disabled = sending;
    var label = button.querySelector('.kik-button__label');
    if (!label) return;
    if (sending) {
      label.dataset.harumOriginalText = label.textContent;
      label.textContent = 'Sending…';
    } else if (label.dataset.harumOriginalText) {
      label.textContent = label.dataset.harumOriginalText;
    }
  }

  function send(form, source) {
    if (form.dataset.harumSubmitting) return;
    form.dataset.harumSubmitting = '1';
    setSending(form, true);

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildPayload(form, source)),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('inquiry api ' + response.status);
        showSuccess(form);
      })
      .catch(function () {
        /* fall back to the native Shopify /contact submission (same behaviour
           as before this script existed) so the inquiry is not lost */
        form.submit();
      })
      .finally(function () {
        delete form.dataset.harumSubmitting;
        setSending(form, false);
      });
  }

  function attach(form, source) {
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;

    /* type="button" so clicking it fires no submit event, keeping Shopify's
       captcha-bootstrap listener (which force-submits the form) out of play */
    button.type = 'button';
    button.classList.add('harum-inquiry-send');
    button.addEventListener('click', function () {
      if (!form.reportValidity()) return; /* native required/pattern bubbles */
      send(form, source);
    });

    /* Enter in a text input still triggers an implicit submit event */
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation(); /* keep it away from captcha-bootstrap */
      send(form, source);
    });
  }

  function init() {
    var wrapper = document.querySelector('.harum-imported-page');
    if (!wrapper || !window.fetch) return;
    var match = wrapper.className.match(/harum-imported-page--([\w-]+)/);
    var source = match ? match[1] : 'unknown';
    var forms = wrapper.querySelectorAll('form.contact-form[action^="/contact"]');
    Array.prototype.forEach.call(forms, function (form) {
      attach(form, source);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
